export class CellData {
    date: string;
    index: number;
    value: number;

    constructor(date: string, index: number, value: number) {
        this.date = date;
        this.index = index;
        this.value = value;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/models/cell-data.ts